module.exports = __webpack_public_path__ + "img/Presentation13.fa4f6dd9.png";